/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as KitRouteImport } from './routes/kit'
import { Route as WorkbenchRouteImport } from './routes/workbench'
import { Route as CCodeRouteImport } from './routes/c.$code'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkbenchRoute = WorkbenchRouteImport.update({
  id: '/workbench',
  path: '/workbench',
  getParentRoute: () => rootRouteImport,
} as any)
const CCodeRoute = CCodeRouteImport.update({
  id: '/c/$code',
  path: '/c/$code',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/kit': typeof KitRoute
  '/workbench': typeof WorkbenchRoute
  '/c/$code': typeof CCodeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/kit': typeof KitRoute
  '/workbench': typeof WorkbenchRoute
  '/c/$code': typeof CCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/kit': typeof KitRoute
  '/workbench': typeof WorkbenchRoute
  '/c/$code': typeof CCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/account' | '/kit' | '/workbench' | '/c/$code'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/account' | '/kit' | '/workbench' | '/c/$code'
  id: '__root__' | '/' | '/account' | '/kit' | '/workbench' | '/c/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  KitRoute: typeof KitRoute
  WorkbenchRoute: typeof WorkbenchRoute
  CCodeRoute: typeof CCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kit': {
      id: '/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workbench': {
      id: '/workbench'
      path: '/workbench'
      fullPath: '/workbench'
      preLoaderRoute: typeof WorkbenchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$code': {
      id: '/c/$code'
      path: '/c/$code'
      fullPath: '/c/$code'
      preLoaderRoute: typeof CCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  KitRoute: KitRoute,
  WorkbenchRoute: WorkbenchRoute,
  CCodeRoute: CCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
